import { Navigate, Outlet } from 'react-router-dom'
import { useStore } from '@/store/Store'

type Role = 'OWNER' | 'ADMIN' | 'STAFF'

export function RequireRole({
  roles,
  redirectTo = '/dashboard',
}: {
  roles: Role[]
  redirectTo?: string
}) {
  const {
    state: { userInfo },
  } = useStore()

  if (!userInfo) return <Navigate to='/login' />
  const role = userInfo.user.role as Role
  if (!roles.includes(role)) return <Navigate to={redirectTo} />

  return <Outlet />
}
